import { Box, Link } from "@mui/material";
import { faComments, faLink } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StyledDivider from "@/src/components/common/styled-divider/styled-divider";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import type Comment from "@/src/_types/Comment/comment";
import NextLink from "next/link";

const ArticleMetrics = (
    {
        comments
    }: {
        comments: Comment[];
    }
) => (
    <Box>
        <StyledDivider
            label={"Comments"}
            icon={faComments}
        />
        <Link component={NextLink} href="#comments" underline="none">
            <SpanTypography fontSize={'.875rem'} mr={.25}>
                <FontAwesomeIcon
                    icon={faLink}
                />
            </SpanTypography>
            <SpanTypography fontSize={'.875rem'} mr={.25}>
                Number of Comments:
            </SpanTypography>
            <SpanTypography fontSize={'.875rem'}>
                {
                    comments.length
                }
            </SpanTypography>
        </Link>
    </Box>
);

export default ArticleMetrics;